export const SALON_GROUP_REDUCER_KEY = 'salonGroup';

export const GET_SALON_GROUP = `${SALON_GROUP_REDUCER_KEY}/GET_SALON_GROUP`;
export const GET_SALON_GROUP_SUCCESS = `${SALON_GROUP_REDUCER_KEY}/GET_SALON_GROUP_SUCCESS`;
export const GET_SALON_GROUP_FAILURE = `${SALON_GROUP_REDUCER_KEY}/GET_SALON_GROUP_FAILURE`;
